export default "__VITE_ASSET__ClBXgrY8__"